import { Component, Input, OnInit, Output, EventEmitter, DoCheck, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'creative-label',
  templateUrl: './creative-label.component.html',
  styleUrls: ['./creative-label.component.less'],
})
export class CreativeLabelComponent implements OnInit, DoCheck, OnChanges {
  @Input() id;
  /**
   * 数据源
   */
  @Input() data: object = {
    group: [
      {
        label: '模板1',
        value: 1,
        children: ['祛痘', '去黑头', '祛痘印', '美白'],
      },
      { label: '模板2', value: 2 },
      { label: '模板3', value: 3 },
      { label: '模板4', value: 4 },
    ],
    list: ['祛痘', '去黑头', '祛痘印', '美白'],
  };
  /**
   * 左侧数据显示框宽度
   */
  @Input() leftWidth: string = '252px';
  /**
   * 操作数据
   */
  @Output() change = new EventEmitter();
  @Output() newChange = new EventEmitter();
  /**
   * 选择的模板信息
   */
  selectTplData: object = {};
  /**
   * 选择的标签信息
   */
  selectLabelData: any = [];
  /**
   * 添加标签时，输入框内容
   */
  addLabelContent: string = '';
  /**
   * 添加的标签数据
   */
  addLabelData: any = [];
  /**
   * 选择的历史标签
   */
  selectList: any = [];

  constructor() {}

  ngOnInit(): void {}

  ngDoCheck(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.id != undefined) {
      this.selectTplData['value'] = changes.id.currentValue;
    }
  }

  /**
   * 选择标签模板
   * @param tplElement
   */
  selectTpl(tplElement: any): void {
    if (tplElement['value'] == this.selectTplData['value']) {
      return;
    }
    if (tplElement.children == undefined) {
      return;
    }
    this.selectTplData = { ...tplElement };
    this.selectLabelData = [...tplElement['children']];
    this.addLabelData = [];

    this.saveTpl2();
  }
  delTpl(v: any, i: any, e: any): void {
    e.stopPropagation();
    // this.data['group'].splice(i, 1);
    this.change.emit({ event: 'del', target: v });
  }

  /**
   * 点击添加按钮
   */
  addLabel(): void {
    const addLabelContent = this.addLabelContent;
    if (addLabelContent == '') {
      return;
    }
    const labelArray = addLabelContent
      .trim()
      .split(' ')
      .filter((s) => {
        return s && s.trim();
      });
    const addLabelData = this.addLabelData;
    const selectLabelCount = this.selectLabelData.length;
    labelArray.map((item) => {
      if (addLabelData.indexOf(item) > -1 || item.length > 10 || addLabelData.length + selectLabelCount > 19) {
      } else {
        addLabelData.push(item);
      }
    });
    this.addLabelData = [...addLabelData];
    this.addLabelContent = '';
    console.log(addLabelData);

    this.saveTpl2();
  }

  /**
   * 移除选择的label
   * @param type
   * @param index
   */
  delLabel(type: string, index: number): void {
    if (type == 'add') {
      const addLabelData = this.addLabelData;
      addLabelData.splice(index, 1);
      this.addLabelData = [...addLabelData];
    }
    if (type == 'select') {
      const selectLabelData = this.selectLabelData;
      selectLabelData.splice(index, 1);
      this.selectLabelData = [...selectLabelData];
    }

    this.saveTpl2();
  }

  /**
   * 清空数据
   */
  clear(): void {
    this.addLabelData = [...[]];
    this.selectLabelData = [...[]];

    this.saveTpl2();
  }

  /**
   * 提示保存模板
   */
  saveTpl(): void {
    this.change.emit({ event: 'save', target: {} });
  }
  saveTpl2(): void {
    const response = { chkecData: this.selectTplData, add: [], save: [] };
    this.addLabelData.map((item) => {
      response.add.push(item);
    });
    this.selectLabelData.map((item) => {
      response.save.push(item);
    });
    this.change.emit({ event: 'data', target: response });
  }

  /**
   * 选择历史标签
   * @param item
   */
  selectItem(item: any): void {
    const selectLabelData = this.selectLabelData;
    if (selectLabelData.indexOf(item) > -1) {
      selectLabelData.splice(selectLabelData.indexOf(item), 1);
    } else {
      selectLabelData.push(item);
    }
    this.selectLabelData = [...selectLabelData];
    console.log(this.selectLabelData);

    this.saveTpl2();
  }
}
